import { useState, useCallback, useEffect } from 'react'
import { HiMiniWallet, HiOutlineInformationCircle, HiCloudArrowDown, HiCloud } from 'react-icons/hi2'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../../../Components/ui/accordion'

import { Pagination } from '../../../../Components/Pagination'
import { calcComparative } from '../../../../Components/SalaryBand/Utils/Calc'
import Masks from '../../../../Utils/masks'

import { Band } from '../../../../Components/SalaryBand/Band'
import Loading from '../../../../Components/Loading/Loading'
import { Filter } from '../../../../Components/Filter/Filter'

import { salariesAndBenefitsTranslate, SalaryComparativeTranslate, salaryTitle } from '../../../../i18n/translatedMessages'
import { useIntl } from 'react-intl'

import SalaryBand from '../../../../API/Services/Salary/SalaryBand'

import { FlagArgentina, FlagBrasil, FlagChile, FlagColombia, FlagEcuador, FlagMexico, FlagPeru, FlagUruguay } from '../../../../Icons/Flags'

import { populateTemplate } from '../../../../libs/excel'
import { FormJobMatch } from '../../../../Components/Employee/Form/formJobMatch'
import { getEmployeesURL } from '../../../../API/Employee/Employee'

const flags = {
	Argentina: <FlagArgentina width='28px' height='28px' />,
	Brasil: <FlagBrasil width='28px' height='28px' />,
	Chile: <FlagChile width='28px' height='28px' />,
	Colombia: <FlagColombia width='28px' height='28px' />,
	Ecuador: <FlagEcuador width='28px' height='28px' />,
	Mexico: <FlagMexico width='28px' height='28px' />,
	Perú: <FlagPeru width='28px' height='28px' />,
	Uruguay: <FlagUruguay width='28px' height='28px' />,
}

export default function Index() {
	const token = localStorage.getItem('token')
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	const [data, setData] = useState([])
	const [filters, setFilters] = useState(null)
	const [loadingReport, setLoadingReport] = useState(null)
	const [loadingExcel, setLoadingExcel] = useState(null)

	const [loading, setLoading] = useState(true)

	const [currentPage, setCurrentPage] = useState(1)
	const [totalData, setTotalData] = useState(0)
	const [countData, setCountData] = useState(0)
	//const itemsPerPage = 10
	const [selectedItem, setSelectedItem] = useState(null)
	const [itemData, setItemData] = useState(null)
	const [jobMatchOpen, setJobMatchOpen] = useState(false)

	const handlePageChange = page => {
		setCurrentPage(page)
	}

	const loadData = useCallback(async () => {
		try {
			const company = JSON.parse(localStorage.getItem('user')).id
			setLoading(true)
			let queryString = `page=${currentPage}&`

			if (filters) {
				queryString =
					queryString +
					Object.entries(filters)
						.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
						.join('&')
			}

			const userId = JSON.parse(localStorage.getItem('user')).id
			const { employees, count } = await SalaryBand.getEmployees(userId, queryString)

			const employeeImgs = await getEmployeesURL(company, token)

			const updatedEvaluations = employees.map(item => ({
				...item,
				profileImg: employeeImgs.find(img => img.mydnaUserEmail === item.mydna_email_position)?.url || null,
			}))

			const sortedEmployees = [...updatedEvaluations].sort((a, b) => a.name.localeCompare(b.name))

			setData(sortedEmployees)
			setCountData(employees.length)
			setTotalData(count)
		} catch (error) {
			console.error(error)
		} finally {
			setLoading(false)
		}
	}, [filters, currentPage])

	useEffect(() => {
		loadData()
	}, [loadData])

	const donwloadReport = async id => {
		let bringReport = null
		try {
			setLoadingReport(id)
			const getData = await SalaryBand.getReportDataEmployee(id)
			if (getData) {
				bringReport = await SalaryBand.getReportEmployee(getData)
			}
		} catch (error) {
		} finally {
			setLoadingReport(null)
			if (bringReport) {
				return window.open(
					`https://smtm.co/v1/reports/api_recover?authorization=19c073e1768a3cbf6e9d76390e640f3b&email=${bringReport.report_sent.report_info.params.email}&code=${bringReport.report_sent.report_info.params.code}`,
					'_blank',
					'noopener,noreferrer'
				)
			}
		}
	}

	const createTemplate = async () => {
		try {
			setLoadingExcel(true)
			const userId = JSON.parse(localStorage.getItem('user')).id
			const data = await SalaryBand.dataToExcel(userId)
			populateTemplate(data, language)
		} catch {
		} finally {
			setLoadingExcel(null)
		}
	}

	const handleJobMatchClick = item => {
		setSelectedItem(item)
		setJobMatchOpen(true)
	}

	const handleChange = event => {
		loadData()
	}

	if (loading) return <Loading />

	return (
		<>
			<FormJobMatch handleChange={handleChange} user={selectedItem} isOpen={jobMatchOpen} onClose={() => setJobMatchOpen(false)} />
			<div className='tw-h-full tw-w-full tw-pr-10'>
				<div className='tw-flex tw-justify-between tw-items-start'>
					<div className='tw-w-10/12'>
						<h3 className='tw-flex tw-items-center tw-gap-2 tw-font-bold tw-mb-4'>
							{/* <HiMiniWallet className='tw-text-blue-400' /> */}
							{salaryTitle.titlePosiciones}
						</h3>
						<div className='tw-text-base tw-mb-4'>{SalaryComparativeTranslate.subtitle}</div>
					</div>
					{data && data.length > 0 && (
						<button
							onClick={createTemplate}
							className='tw-bg-purple tw-text-white hover:tw-bg-purple-400 hover:tw-text-white active:tw-bg-purple-600 border-0 tw-px-3 tw-py-2 tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-flex-nowrap'
						>
							{loadingExcel ? (
								<svg
									className='tw-animate-spin -tw-ml-1 tw-mr-3 tw-h-5 tw-w-5 tw-text-purple'
									xmlns='http://www.w3.org/2000/svg'
									fill='none'
									viewBox='0 0 24 24'
								>
									<circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
									<path
										className='opacity-75'
										fill='#FFF'
										d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
									/>
								</svg>
							) : (
								<HiCloudArrowDown size={22} />
							)}
							<span>{salariesAndBenefitsTranslate.salaryDownloadList}</span>
						</button>
					)}
				</div>
				{data && data.length > 0 ? (
					<>
						<div className='tw-mb-4 tw-mt-4'>
							<Filter setFilters={setFilters} filters={filters} />
						</div>
						<div className='tw-w-full tw-space-y-2 tw-rounded-md tw-overflow-hidden border'>
							<div className='tw-flex tw-w-full tw-bg-gray-100 tw-px-4 tw-py-2'>
								<div className='tw-font-bold tw-w-3/12 tw-flex tw-justify-start'>{salariesAndBenefitsTranslate.salaryRoleEmployee}</div>
								<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>{salariesAndBenefitsTranslate.salaryRoleCoin}</div>
								<div className='tw-font-bold tw-w-2/12 tw-flex tw-justify-center'>{salariesAndBenefitsTranslate.salaryRoleSalary}</div>
								<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>Mercado</div>
								<div className='tw-font-bold tw-w-2/12 tw-flex tw-justify-center'>Comparativo</div>
								<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>Info</div>
								<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>Reporte</div>
								<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'></div>
							</div>
							<div className='tw-max-h-[calc(100vh_-_400px)] tw-overflow-y-auto px-2'>
								{data.map(item => (
									<Accordion type='single' collapsible className='border-bottom tw-pb-4' key={item.employee_id}>
										<AccordionItem value='item-1'>
											<div key={item.employee_id} className='tw-flex tw-w-full tw-h-[100px]'>
												<div className='tw-w-3/12 tw-flex tw-items-center tw-gap-8'>
													<div
														title={item.employee_id}
														className='tw-w-[60px] tw-h-[60px] border tw-rounded-full tw-flex tw-items-center tw-justify-center tw-relative tw-text-purple-400 tw-text-4xl'
													>
														{item.profileImg ? (
															<img
																src={item.profileImg}
																alt=''
																className='rounded-circle tw-w-[50px] tw-h-[50px] 2xl:tw-w-[60px] 2xl:tw-h-[60px] tw-object-cover'
															/>
														) : (
															<span>{item.name?.charAt(0)}</span>
														)}
														{
															<div
																title={item.country.label}
																className='tw-absolute tw-bg-purple tw-w-[27px] tw-h-[27px] tw-bottom-[-10px] tw-right-[-10px] tw-rounded-full tw-flex tw-items-center tw-justify-center'
															>
																{flags[item.country.label]}
															</div>
														}
													</div>
													<div className=''>
														<h4 className='tw-text-base tw-font-bold tw-m-0 tw-p-0'>{item?.name}</h4>
														<span className='tw-text-sm tw-text-gray-600'>{item?.jobname}</span>
													</div>
												</div>
												<div className='tw-w-1/12 tw-flex tw-flex-col tw-items-center tw-justify-center'>
													<h4 className='tw-text-base tw-p-0'>{item.currency}</h4>
													<span>{item.salary_model}</span>
												</div>
												<div className='tw-w-2/12 tw-flex tw-items-center tw-justify-center'>
													{item.monthly_salary === 0 || item.monthly_salary === null ? (
														<span className='tw-bg-gray-200 tw-px-3 tw-rounded-full tw-text-gray-500'>
															{salariesAndBenefitsTranslate.salaryNotInfomed}
														</span>
													) : (
														Masks.setDots(item.monthly_salary, false)
													)}
												</div>
												<div className='tw-w-1/12 tw-flex tw-items-center tw-justify-center'>
													{Masks.setDots(item.market_salary, false) || (
														<span
															className='tw-bg-green-500 tw-px-3 tw-rounded-full tw-text-white tw-cursor-pointer'
															onClick={() => handleJobMatchClick(item)}
														>
															Seleccionar {/* {salariesAndBenefitsTranslate.salaryProcessing} */}
														</span>
													)}
												</div>
												<div className='tw-w-2/12 tw-flex tw-items-center tw-justify-center'>
													{calcComparative(Number(item.market_salary), item.monthly_salary)}
												</div>
												<div className='tw-w-1/12 tw-flex tw-items-center tw-justify-center'>
													<HiOutlineInformationCircle size={28} className='tw-text-purple cursor-pointer hover:tw-text-purple-400 ' />
												</div>
												<div className='tw-w-1/12 tw-flex tw-items-center tw-justify-center'>
													{loadingReport === item.employee_id ? (
														<svg
															className='tw-animate-spin -tw-ml-1 tw-mr-3 tw-h-5 tw-w-5 tw-text-purple'
															xmlns='http://www.w3.org/2000/svg'
															fill='none'
															viewBox='0 0 24 24'
														>
															<circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
															<path
																className='opacity-75'
																fill='currentColor'
																d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
															/>
														</svg>
													) : item.market_salary ? (
														<button
															className='border-0 tw-bg-transparent p-0 m-0'
															onClick={() => {
																donwloadReport(item.employee_id)
															}}
														>
															<HiCloudArrowDown
																size={28}
																className='tw-text-purple cursor-pointer hover:tw-text-purple-400 active:tw-text-purple-600'
															/>
														</button>
													) : (
														<HiCloud size={28} className='tw-text-gray-300' />
													)}
												</div>
												<div className='tw-w-1/12 tw-flex tw-items-center tw-justify-center'>
													<AccordionTrigger
														icon={false}
														className='tw-bg-gray-100 tw-text-base tw-text-purple border-0 tw-rounded-md tw-p-2 hover:tw-bg-gray-200 active:tw-bg-purple-400 active:tw-text-white'
													>
														Ver Banda
													</AccordionTrigger>
												</div>
											</div>
											<AccordionContent>
												<Band employee={item} />
											</AccordionContent>
										</AccordionItem>
									</Accordion>
								))}
							</div>
						</div>
						<div className='tw-flex tw-w-full tw-items-start tw-justify-between'>
							<div className='tw-w-7 tw-h-10 ' />
							<Pagination currentPage={currentPage} totalPages={Math.ceil(totalData / 50)} onPageChange={handlePageChange} />
							<div className='tw-text-sm tw-text-gray-600 tw-mt-1'>
								{salariesAndBenefitsTranslate.showDataAmount1} {countData} {salariesAndBenefitsTranslate.showDataAmount2} de {totalData}
							</div>
						</div>
					</>
				) : (
					<div className='tw-flex tw-justify-center tw-items-center tw-h-96'>Ningún colaborador registrado</div>
				)}
			</div>
		</>
	)
}
